import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { ConnectedGallery, ConnectionsService } from 'src/app/Services/connections.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';

/**
 * Artist "Connection requests" page (Phase-2 nav, Messages section).
 *
 * Lists incoming, still-pending invitations a gallery has sent to this artist
 * (from the connected-galleries feed with includeInvited), with Accept / Decline.
 */
@Component({
    selector: 'app-connection-requests',
    templateUrl: './connection-requests.component.html',
    styleUrls: ['./connection-requests.component.css'],
    standalone: false
})
export class ConnectionRequestsComponent implements OnInit {
    public requests: ConnectedGallery[] = [];
    public loaded = false;
    private artistId = '';

    constructor(
        private auth: AuthService,
        private connections: ConnectionsService,
        private notifications: NotificationsService,
        private spinner: NgxSpinnerService
    ) { }

    public ngOnInit(): void {
        this.artistId = this.auth.getUserId();
        this.load();
    }

    private load(): void {
        this.spinner.show();
        this.connections.getConnectedGalleries(this.artistId, true).subscribe({
            next: (rows) => {
                // Incoming invitations a gallery sent that the artist hasn't accepted yet.
                this.requests = (rows || []).filter(r => !r.IsInviteAccepted && !r.IsInitiatedByArtist);
                this.loaded = true;
                this.spinner.hide();
            },
            error: () => { this.loaded = true; this.spinner.hide(); }
        });
    }

    public accept(req: ConnectedGallery): void {
        if (!req.ConnectionId) { return; }
        this.spinner.show();
        this.connections.acceptConnectionRequest(req.ConnectionId).subscribe({
            next: (res: ResponseObject) => {
                this.spinner.hide();
                if (res?.Success) {
                    this.notifications.showNotification('Connected', `You're now connected with ${req.Name}.`, NotificationTypes.Success);
                    this.requests = this.requests.filter(r => r !== req);
                } else {
                    this.notifications.showNotification('Could not accept', res?.ResponseMessage || 'Please try again.', NotificationTypes.Error);
                }
            },
            error: () => { this.spinner.hide(); this.notifications.showNotification('Could not accept', 'Please try again.', NotificationTypes.Error); }
        });
    }

    public decline(req: ConnectedGallery): void {
        this.spinner.show();
        this.connections.deleteConnectedGallery(req.Id).subscribe({
            next: (res: ResponseObject) => {
                this.spinner.hide();
                if (res?.Success) {
                    this.notifications.showNotification('Request declined', `Declined the request from ${req.Name}.`, NotificationTypes.Info);
                    this.requests = this.requests.filter(r => r !== req);
                } else {
                    this.notifications.showNotification('Could not decline', res?.ResponseMessage || 'Please try again.', NotificationTypes.Error);
                }
            },
            error: () => { this.spinner.hide(); this.notifications.showNotification('Could not decline', 'Please try again.', NotificationTypes.Error); }
        });
    }
}
